import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userCarInsurance: { carYear: '', carBrand: '', carModel: '', carVersion: '' },
};

const carInsuranceSlice = createSlice({
  name: 'carInsurance',
  initialState,
  reducers: {
    setCarInsurance(state, action) {
      // state.addCarInsurance = action.payload;
      state.userCarInsurance = {
        ...state.userCarInsurance,
        ...action.payload,
      };
    },
    setValidCar(state, action) {
      return { ...state, ...action.payload };
    },
    setValidPatent(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

const { actions, reducer } = carInsuranceSlice;

export const { setCarInsurance, setValidCar, setValidPatent } = actions;

export const setCarInsuranceAction = (data) => async (dispatch) => {
  dispatch(setCarInsurance(data));
};

export const setValidCarAction = (data) => async (dispatch) => {
  dispatch(setValidCar(data));
};

export const setValidPatentAction = (data) => async (dispatch) => {
  dispatch(setValidPatent(data));
};

export default reducer;
